var showConsoleLogs = function showConsoleLogs() {
  if (typeof window !== 'undefined') {
    var _window;
    if ((_window = window) !== null && _window !== void 0 && _window.localStorage && window.localStorage.getItem('DEBUG') === 'colors' || window.localStorage.getItem('DEBUG') === true) {
      return true;
    }
  }
  return false;
};

export { showConsoleLogs };
//# sourceMappingURL=debug.js.map
